import Reflux from 'reflux';
/*
	AMP Player Events

	https://community.akamai.com/docs/DOC-5549-amp-api#jive_content_id_Player_Events

*/
const AmpPlayerEvents = [
	'activestatechange',
	'canplay',
	'canplaythrough',
	'displaystatechange',
	'durationchange',
	'ended',
	'error',
	'initialized',
	'loadedmeatadata',
	'loadstart',
	'mediaPlayerID3Updated',
	'mediaPlayeronTextData',
	'mediasequenceended',
	'mediasequencestarted',
	'mediumchange',
	'mutechange',
	'pause',
	'play',
	'playbacktargetchange',
	'playing',
	'playrequest',
	'playstatechange',
	'progress',
	'ready',
	'seeked',
	'seeking',
	'started',
	'timedmetadata',
	'timeupdate',
	'volumechange',
	'waiting',
	'setMedia' // Switch the video with AMP
];


const AmpPlayerActions = Reflux.createActions(AmpPlayerEvents);

export {AmpPlayerActions};
export {AmpPlayerEvents};





// WEBPACK FOOTER //
// ./modules/actions/amp-player-actions.js